var render, staticRenderFns
import script from "./BrandCampaignEditPage.vue?vue&type=script&lang=js"
export * from "./BrandCampaignEditPage.vue?vue&type=script&lang=js"
import style0 from "./BrandCampaignEditPage.vue?vue&type=style&index=0&id=80846a4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports